import { VoucherQueryParams } from '../../../pages/reporting/vouchers/types'
import { Company } from '../../../types/company/Company'
import { ContextFilters } from '../../../types/context/ContextFilters'
import { VoucherOptionsProps } from './useVoucherOptions'

export interface VoucherQueryWithDimensions extends VoucherQueryParams {
  companyId?: Company['id']
}

const voucherQueryKeys = {
  all: [{ scope: 'voucher' }] as const,
  lists: () => [{ ...voucherQueryKeys.all[0], entity: 'list' }] as const,
  list: (params: VoucherOptionsProps) => [{ ...voucherQueryKeys.lists()[0], ...params }] as const,
  types: () => [{ ...voucherQueryKeys.all[0], entity: 'types' }] as const,
  type: (params: VoucherOptionsProps) => [{ ...voucherQueryKeys.types()[0], ...params }] as const,
  details: () => [{ ...voucherQueryKeys.all[0], entity: 'detail' }] as const,
  detail: (context: Pick<ContextFilters, 'companyId'>, id: number) =>
    [{ ...voucherQueryKeys.details()[0], ...context, id }] as const
}

export default voucherQueryKeys
